import { createContext } from 'react'

export const SelectedRecordNameContext = createContext<string | undefined>(
  undefined
)

export const SelectedRecordNameDispatchContext = createContext<
  React.Dispatch<string> | undefined
>(undefined)
